<div class="ib-digital-menu-mmb__allergen-info--container">
    <div class="ib-digital-menu-mmb__allergens-list-wrapper" ibFocusin tabindex="0"
        [ngClass]="{'ib-digital-menu-mmb__allergens-list-wrapper--white':!show_allergens}">
        <div class="ib-digital-menu-mmb__allergen-info--title">
            <h3 *ngIf="show_allergens">
                {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_ALLERGENS_AND_INFORMATION' | translate}}
            </h3>
            <h3 *ngIf="!show_allergens">{{'MOD_INFO_TITLE' | translate}}</h3>
        </div>
        <div class="ib-flex__row" aria-hidden="true" *ngIf="show_allergens">
            <div *ngFor="let allergen of allAllergens" class="ib-digital-menu-mmb__allergen-info ib-flex__row--nowrap">
                <img [alt]="allergen.name | translate" [title]="allergen.name | translate" [src]="allergensIconUrl + '/' + allergen.image" />
                <p class="ib-digital-menu-mmb__allergen-info__img">{{allergen.name | translate}}</p>
            </div>
        </div>
        <div class="ib-digital-menu-mmb__allergen-info--disclaimer">
            <span>{{disclaimer}}</span>
        </div>
    </div>
</div>
